import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, { FunctionComponent } from 'react';

import './ErrorMessage.scss';

interface IErrorMessageProps {
    message?: string;
}

export const ErrorMessage: FunctionComponent<IErrorMessageProps> = function ({ message }) {
    return (
        <p className="errorMessage">
            <FontAwesomeIcon icon="exclamation-triangle" className="errorMessage_icon" />
            {'An error has occurred: '} <br />
            {message}
        </p>
    );
}



